// src/auth/oidcConfig.js
import { UserManager, WebStorageStateStore } from "oidc-client";

const oidcConfig = {
  authority: process.env.REACT_APP_AUTHORITY,
  client_id: process.env.REACT_APP_CLIENT_ID,
  redirect_uri: process.env.REACT_APP_REDIRECT_URI,
  response_type: "code", // 'code' is the recommended response type for OIDC
  scope: "openid profile amnathrigAPI roles", // The scopes that determine what information is requested from the user
  post_logout_redirect_uri: process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI,
  userStore: new WebStorageStateStore({ store: window.localStorage }),

  // Silent renewal configuration
  automaticSilentRenew: true,
  silent_redirect_uri: process.env.REACT_APP_SILENT_REDIRECT_URI,
  checkSessionInterval: 60000, // Check session every 60 seconds
  accessTokenExpiringNotificationTime: 300, // Notify 5 minutes before expiration

  // Additional token management
  includeIdTokenInSilentRenew: true,
  loadUserInfo: true,

  // Token validation
  clockSkew: 60, // Allow 60 seconds clock skew
};

const userManager = new UserManager(oidcConfig);

// Make userManager available globally for debugging and direct access
window.userManager = userManager;

// Set up automatic token renewal event handlers
userManager.events.addAccessTokenExpiring(() => {
  console.log("🔄 Token expiring, attempting silent renewal...");
});

userManager.events.addAccessTokenExpired(() => {
  console.log("❌ Token expired, redirecting to login...");
  userManager.signinRedirect();
});

userManager.events.addSilentRenewError((error) => {
  console.error("❌ Silent renewal error:", error);
  // Redirect to login if silent renewal fails
  userManager.signinRedirect();
});

userManager.events.addUserLoaded((user) => {
  console.log("✅ User loaded/refreshed:", user.profile.name);
  console.log(
    "🔑 Token expires at:",
    new Date(user.expires_at * 1000).toLocaleString()
  );
});

userManager.events.addUserSignedIn(() => {
  console.log("✅ User signed in successfully");
});

userManager.events.addUserSignedOut(() => {
  console.log("👋 User signed out");
});

// Add error event handler
userManager.events.addUserSessionChanged(() => {
  console.log("🔄 User session changed");
});

export default userManager;
